<template>
  <div class="lucy-card pa-3">
    <div class="d-flex align-center mb-2">
      <span class="lucy-card__avatar mr-2">L</span>
      <strong class="lucy-card__name">{{ $t('lucy.name') }}</strong>
    </div>
    <h4 class="lucy-card__title mb-2">{{ title }}</h4>
    <p class="lucy-card__body mb-3">{{ body }}</p>
    <div class="d-flex flex-wrap" style="gap: 6px">
      <v-btn
        v-if="showGo"
        x-small
        depressed
        class="text-none"
        color="ai"
        dark
        @click="$emit('go')"
      >
        {{ goLabel }}
      </v-btn>
      <v-btn
        x-small
        outlined
        class="text-none"
        color="ai"
        @click="$emit('ask')"
      >
        {{ $t('lucy.askMore') }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
    import Vue, {PropType} from 'vue';
    import {SeoScoreMetricName, SeoScoreStatus} from '@/model/SeoScore';
    import SeoScoreMetricsMixin from '@/mixins/SeoScoreMetricsMixin';
    import {lucyAdviceForMetric, LucyAdvice} from '@/service/lucyCoach';
    import {Article} from '@/model/Article';

    type LucyCardVm = Vue & {
        getStatus(name: SeoScoreMetricName): SeoScoreStatus;
    };

    export default Vue.extend({
        name: 'LucyCard',
        mixins: [SeoScoreMetricsMixin],
        props: {
            metric: {
                type: String as PropType<SeoScoreMetricName>,
                required: true
            }
        },
        computed: {
            advice(): LucyAdvice {
                const vm = this as unknown as LucyCardVm;
                return lucyAdviceForMetric(
                    this.metric,
                    vm.getStatus(this.metric),
                    this.$store.getters.article as Article,
                    (key, values) => this.$t(key, values as never),
                    (key) => this.$te(key)
                );
            },
            title(): string {
                return String(this.$t('seoScore.' + this.metric + '.label'));
            },
            body(): string {
                return this.advice.body;
            },
            showGo(): boolean {
                return Boolean(this.advice.goMetric);
            },
            goLabel(): string {
                if (this.advice.goMetric && this.advice.goMetric !== this.metric) {
                    return String(this.$t('lucy.goToNamed', [this.$t('seoScore.' + this.advice.goMetric + '.label')]));
                }
                return String(this.$t('lucy.goThere'));
            }
        }
    });
</script>

<style scoped lang="sass">
.lucy-card
    background: var(--v-surface-base)
    max-width: 280px

.lucy-card__avatar
    width: 24px
    height: 24px
    border-radius: 50%
    background: linear-gradient(135deg, #cd7ec2, #8e3d82)
    color: #fff
    font-size: 11px
    font-weight: 800
    display: inline-flex
    align-items: center
    justify-content: center

.lucy-card__name
    font-size: 12px

.lucy-card__title
    font-size: 13px
    line-height: 1.3

.lucy-card__body
    font-size: 12.5px
    line-height: 1.45
    color: #445
    margin: 0
</style>
